module.exports = __webpack_public_path__ + "static/nonetwork-89c0cc9b8da1e433a62ec32aa05374d8.png";